

























































import { Component, Prop, Vue } from "vue-property-decorator";
import store from "../store";

@Component
export default class Editarea extends Vue {
  data() {
    return {
      storeData: store.state
    };
  }
  private removeBranch(level: number, position: [number, number, number]) {
    store.removeBranch(level, position);
  }
  private addChildBranch(level: number, position: [number, number, number]) {
    store.addChildBranch(level, position);
  }
}
